import MenuItem from "@mui/material/MenuItem"
import TextField from "@mui/material/TextField"
import { useState } from "react"

import { OFFER_ORDERED_STATUSES, OFFER_STATUS_CHOICES } from "../utils"

export default function OfferStatusTextField({ status, setStatus }) {
  return (
    <TextField
      label="Status"
      select
      value={status}
      onChange={(e) => setStatus(e.target.value)}
    >
      {Object.entries(OFFER_STATUS_CHOICES).map(([status, label]) => (
        <MenuItem key={status} value={status}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  )
}

export function useOfferStatusTextFieldState() {
  const [status, setStatus] = useState(OFFER_ORDERED_STATUSES[0])
  return {
    status,
    setStatus,
  }
}
